module.exports = __webpack_public_path__ + "static/media/botleft.de788a06.svg";